/**
 * ttsModels — какие аудио-модели показывать на какой аудио-странице.
 *
 * Модели озвучки (ElevenLabs) — обычные audio-модели каталога, но музыку они не
 * пишут, а Suno/Mureka больше не озвучивают текст. Поэтому на «Озвучке»
 * (/bots/audio/tts) в выборе модели только модели озвучки, на остальных
 * аудио-страницах — только музыкальные. Одно правило для пикера виджета,
 * мобильного ряда «Модель» и выбора модели при заходе на страницу.
 */
import type { Model } from '../../../data/models'
import { opAvailable, providerOf } from './trackOperations'

export const TTS_ROUTE = '/bots/audio/tts'

/** Модель озвучки: из операций у неё только озвучка текста. */
export function isTtsModelId(modelId: string | null | undefined): boolean {
	return providerOf(modelId) === 'elevenlabs'
}

/** Модель умеет озвучку (submode 'tts'). */
export function supportsTts(modelId: string | null | undefined): boolean {
	return opAvailable('tts', providerOf(modelId))
}

export function isTtsRoute(pathname: string): boolean {
	return pathname.startsWith(TTS_ROUTE)
}

/** Модели страницы: на /bots/audio/tts — только озвучка, на других /bots/audio* —
 *  без неё. Не-аудио модели и страницы вне /bots/audio не трогаем. */
export function modelsForAudioRoute(models: Model[], pathname: string): Model[] {
	if (!pathname.startsWith('/bots/audio')) return models
	const tts = isTtsRoute(pathname)
	return models.filter((m) => m.category !== 'audio' || isTtsModelId(m.id) === tts)
}
